import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";

export interface BarChartProps {
  notStartedCount: string;
  inProgressCount: string;
  submittedCount: string;
  totalCount: string;
  notStartedText: string;
  inProgressText: string;
  inProgressLegend: string;
  completedText: string;
}

export default function BarChart({
  notStartedCount,
  inProgressCount,
  submittedCount,
  totalCount,
  notStartedText,
  inProgressText,
  inProgressLegend,
  completedText
}: BarChartProps): JSX.Element {
  const notStarted = useIntl().formatMessage({
    id: "app.drilldown.notStarted"
  });
  const submitted = useIntl().formatMessage({
    id: "app.drilldown.submitted"
  });

  return (
    <div className="chart">
      <WmChart
        chartType="bar4"
        label={" "}
        valueFormat="amount"
        key="bar4-chart"
        print-mode={true}
      >
        <WmChartSlice
          amount={notStartedCount}
          legend={notStarted}
          key="not_started_count"
          popover-title={notStartedCount + "/" + totalCount}
          popover-text={notStartedText}
        ></WmChartSlice>
        <WmChartSlice
          amount={inProgressCount}
          legend={inProgressLegend}
          key="in_progress_count"
          popover-title={inProgressCount + "/" + totalCount}
          popover-text={inProgressText}
        ></WmChartSlice>
        <WmChartSlice
          amount={submittedCount}
          legend={submitted}
          key="Completed"
          popover-title={submittedCount + "/" + totalCount}
          popover-text={completedText}
        ></WmChartSlice>
      </WmChart>
    </div>
  );
}
